var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 28.4845C3.58803 26.8699 2 24.1204 2 21C2 16.3129 5.58302 12.4626 10.1595 12.0387C11.0956 6.34426 16.0405 2 22 2C27.9595 2 32.9044 6.34426 33.8405 12.0387C38.417 12.4626 42 16.3129 42 21C42 24.1204 40.412 26.8699 38 28.4845M14 28L22 20M22 20L30 28M22 20V38",
    stroke: "#224A91",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.ebf7549dd87264d5cd83a7589a5ff924.svg";
export { ForwardRef as ReactComponent };